import styled from '@emotion/styled';
import { Component } from 'react';

import { Disclaimer } from './desktop/components.js';
import DesktopWarranty from './desktop/index';
import MobileWarranty from './mobile/index';
import Page from '../page';

const WideScreen = styled.div`
  display: none;

  @media (min-width: 1032px) {
    display: block;
  }
`;

const NarrowScreen = styled.div`
  display: none;

  @media (max-width: 1031.9px) {
    display: block;
  }
`;

export default class WarrantyPage extends Component {
  renderDisclaimer() {
    return (
      <Disclaimer>
        See actual warranty for complete details, limitations and requirements.
        <br />
        1Excludes tear-off and disposal costs if required.
        <br />
        2Includes tear-off and disposal costs if required.
        <br />
        *After thermal sealings.
        <br />
        **25-year Algae Resistance coverage requires the use of Owens Corning® Berkshire®, DecoRidge®, DuraRidge®,
        ImpactRidge®, ProEdge®, or RIZERidge®, Hip & Ridge Shingles. If a qualifying Owens Corning® manufactured ridge
        product is not used, the Algae Resistance warranty period is reduced from 25 to 10 years, and the non-prorated
        period will be 1 year. Supreme® shingles feature a 10-year Algae Resistance Limited Warranty. Algae Resistance
        is available on a regional basis. Algae resistance not available on all products, see product guide or{' '}
        <a href="https://www.owenscorning.com">www.owenscorning.com</a> for availability in your area.
        <br />
        ***Minimum 3 required for components to take on coverage period of the shingle, otherwise standard individual
        component warranty terms apply.
        <br />
        ###160 MPH is applicable when Owens Corning component requirements are met and with starter shingles installed
        on both the eaves and rakes. See actual warranty for complete details, limitations, and requirements.
      </Disclaimer>
    );
  }

  render() {
    return (
      <Page>
        <WideScreen>
          <DesktopWarranty activeWarranties={this.props.activeWarranties} />
          {this.renderDisclaimer()}
        </WideScreen>
        <NarrowScreen>
          <MobileWarranty activeWarranties={this.props.activeWarranties} />
          {this.renderDisclaimer()}
        </NarrowScreen>
      </Page>
    );
  }
}
